module.exports = __webpack_public_path__ + "static/img/mobile.1da7a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile.png
// module id = dft9
// module chunks = 1